module.exports = flarum.core.compat['states/PostStreamState'];